import React from 'react';
import styled from 'styled-components';
import { Button, ButtonProps } from '@material-ui/core';
import { Delete } from '@material-ui/icons';

const DeleteButtonStyled = styled(Button)`
    color: ${props => props.theme.red};
    border-color: ${props => props.theme.red};
`;

export const DeleteButton = ({ children, ...props }: ButtonProps): JSX.Element => (
    <DeleteButtonStyled size={'small'} {...props} variant={'outlined'}>
        <Delete />
    </DeleteButtonStyled>
);
